import {
  ContractLanguage,
  ISendTeacherContractReq,
  ITeacherContractDetail,
  ITeacherContractPage,
  ITeacherContractSummary,
  ITeacherContractTemplate,
  ITeacherContractTemplateList,
  TeacherContractStatus,
} from '~/types/teacher-contract'
import http from '~/utils/http'

const BASE = '/admin/teacher-contracts'

export function listContractTemplates() {
  return http.get<ITeacherContractTemplateList>(`${BASE}/templates`)
}

export function saveContractTemplate(
  payload: { name: string; language: ContractLanguage; title: string; body: string },
  id?: number,
) {
  return id
    ? http.put<ITeacherContractTemplate>(`${BASE}/templates/${id}`, payload)
    : http.post<ITeacherContractTemplate>(`${BASE}/templates`, payload)
}

export function deleteContractTemplate(id: number) {
  return http.delete(`${BASE}/templates/${id}`)
}

export function listContracts(params: {
  page: number
  size: number
  status?: TeacherContractStatus
  keyword?: string
  from?: number
  to?: number
  teacherId?: number
}) {
  return http.get<ITeacherContractPage>(BASE, { params })
}

export function getContract(id: number) {
  return http.get<ITeacherContractDetail>(`${BASE}/${id}`)
}

/** 渲染 PDF 要几秒，放宽超时 */
export function previewContract(payload: ISendTeacherContractReq) {
  return http.post<Blob>(`${BASE}/preview`, payload, { responseType: 'blob', timeout: 60_000 })
}

export function sendContract(payload: ISendTeacherContractReq) {
  return http.post<ITeacherContractSummary>(BASE, payload, { timeout: 60_000 })
}

export function voidContract(id: number, reason: string) {
  return http.post<ITeacherContractSummary>(`${BASE}/${id}/void`, { reason })
}

export function downloadContractPdf(id: number, original = false) {
  return http.get<Blob>(`${BASE}/${id}/pdf`, {
    params: { original },
    responseType: 'blob',
    timeout: 60_000,
  })
}

/** 接口出错时 body 是文字；blob 请求的错误也要读成文字 */
export async function errorText(err: unknown, fallback = '操作失败，请稍后再试'): Promise<string> {
  const failure = err as { response?: { data?: unknown }; message?: string } | undefined
  const data = failure?.response?.data
  if (data instanceof Blob) {
    try {
      return (await data.text()) || fallback
    } catch {
      return fallback
    }
  }
  return (typeof data === 'string' && data) || failure?.message || fallback
}
